import FactCard from "@afa-shared/afa-components/dist/FactCard";
import { StandardLink } from "@components/Link/StandardLink";
import Message from "@components/Message/Message";
import { getInternalOrExternalIcon } from "@utils/linkIconHelper";

import { Context } from "types/context/Context";

import RichTextRenderer from "../../components/RichTextRenderer";
import { getInformationType } from "./informationBlockHelper";
import { InformationBlockType_informationBlock } from "./queries/contentfulTypes/InformationBlockType";

interface IInformationProps {
  blockData: InformationBlockType_informationBlock | null;
  uniqueKey?: string;
  context?: Context;
}

const InformationBlock = ({ blockData: infoBlock, context, uniqueKey }: IInformationProps) => {
  if (!infoBlock) {
    console.warn("Information block is undefined. Return null until block id populated");

    return null;
  }

  const url = infoBlock?.linkReference?.url;
  const externalReference = infoBlock?.linkReference?.url;
  const internalReference = infoBlock?.linkReference?.reference;
  const globalReference = infoBlock?.linkReference?.globalLinkItem;
  const linkVariant =
    infoBlock?.linkReference?.variant &&
    infoBlock?.linkReference?.variant?.toLowerCase() === "knapp"
      ? "button"
      : "link";
  const linkType = getInternalOrExternalIcon(externalReference, internalReference, globalReference);

  const type: any = getInformationType(infoBlock?.infoVariant?.toLowerCase());

  return (
    <div data-contentful-entry-id={infoBlock.sys.id} data-contentful-field-id="name">
      {type === "blue" || type === "" ? (
        <FactCard
          key={uniqueKey}
          heading={infoBlock?.heading}
          headingVariant={context?.heading?.parentLevel}
          type={type}
          linkType={
            infoBlock?.linkReference && url ? (
              <StandardLink
                type={linkType}
                text={infoBlock?.linkReference?.linkText}
                href={url}
                variant={linkVariant}
              />
            ) : (
              <></>
            )
          }
          data-blockname="faktaruta"
        >
          {infoBlock?.body?.json && (
            <RichTextRenderer
              json={infoBlock?.body?.json}
              links={infoBlock?.body?.links}
              context={context}
            />
          )}
        </FactCard>
      ) : (
        <Message
          key={uniqueKey}
          heading={infoBlock?.heading}
          headingVariant={context?.heading?.parentLevel}
          type={type}
          linkType={
            infoBlock?.linkReference &&
            url && (
              <StandardLink
                type={linkType}
                text={infoBlock?.linkReference?.linkText}
                href={url}
                variant={linkVariant}
              />
            )
          }
          data-blockname="infomation"
        >
          {infoBlock?.body?.json && (
            <RichTextRenderer
              json={infoBlock?.body?.json}
              links={infoBlock?.body?.links}
              context={context}
            />
          )}
        </Message>
      )}
    </div>
  );
};
export default InformationBlock;
